import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class PalmeAvant extends ActionCard {
    static typeId = "PALME_AVANT";
    static cardName = "Palme Avant";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.PALME_AVANT;
    static description = "Echangez l’un de vos moutons avec l'entité qui se trouve immédiatement devant lui.";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 0) return false;
        const duck = gameState.lineOfFire[slotIndex];

        // Can only target own duck that can go to the right
        return duck.team?.id === gameState.getCurrentPlayerTeamId();
    }

    resolve(slotIndex, gameState) {
        gameState.swapDuck(slotIndex, "left");
    }
}
